import { useState } from 'react'
import ButtonFunc from 'ui/buttons/ButtonFunc'
import TreatmentCreateDrawer from '../drawers/TreatmentCreateDrawer'

const CreateTreatmentSchemaForm = () => {
	const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false)

	return (
		<>
			<ButtonFunc
				title='Добавить схему лечения'
				onClick={() => setIsDrawerOpen(true)}
			/>
			<TreatmentCreateDrawer
				open={isDrawerOpen}
				onClose={() => setIsDrawerOpen(false)}
			/>
		</>
	)
}

export default CreateTreatmentSchemaForm
